module.exports = __webpack_public_path__ + "static/media/payments.c7d0cdca.jpeg";